// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".basic-table{display:table;border-collapse:collapse;width:100%}.basic-table__row{display:table-row}.basic-table__text{display:table-cell;padding:8px 35px 8px 0;position:relative;vertical-align:top;min-width:75px}.basic-table__text:last-child{padding-right:0px}.basic-table__text--italicize{font-style:italic}.basic-table__text--label{font-size:12px;color:#506784;text-transform:uppercase;letter-spacing:1px;width:42%}.basic-table__text{word-wrap:normal;word-break:normal}", ""]);
// Exports
module.exports = exports;
